// Filters
import { leavesDate } from '../locale'

var moment = require('moment')
moment.locale('zh-cn')

const LLDate = (value) => {
  return moment(value).format('LL')
}

const formatDateToString = (value, filter) => {
  value = (value == null ? new Date() : value)
  let date = (typeof value === 'object' ? value : new Date(Date.parse(value.replace(/-/g, '/'))))
  if (filter) {
    return moment(date).format(filter)
  } else {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }
}

const formatLeavesDate = function(value, filter) {
  value = (value == null ? new Date() : value)
  let date = (typeof value === 'object' ? value : new Date(Date.parse(value.replace(/-/g, '/'))))
  let leaves = Math.floor((new Date().getTime() - date.getTime()) / 1000)
  if (leaves < 60) {
    return formatString(leavesDate.second, [leaves])
  } else if (leaves < 3600) {
    return formatString(leavesDate.minute, [Math.floor(leaves / 60)])
  } else if (leaves < 3600 * 24) {
    return formatString(leavesDate.hour, [Math.floor(leaves / 3600)])
  } else if (leaves < 3600 * 24 * 7) {
    return formatString(leavesDate.day, [Math.floor(leaves / (3600 * 24))])
  } else {
    if (filter) {
      return moment(value).format(filter)
    } else {
      return LLDate(value)
    }
  }
}

// 取得url参数
const getQueryString = function(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// 格式化文件大小
const formatFileSize = function(size) {
  let mb = parseInt(size / 1024 / 1024)
  if (mb > 0) {
    return mb + 'MB'
  } else {
    let kb = parseInt(size / 1024)
    if (kb > 0) {
      return kb + 'KB'
    } else {
      return size + 'B'
    }
  }
}

// 字符串格式化
const formatString = function(fmt, args) {
  if (args instanceof Array || Object.prototype.toString.call(args) === '[object Array]') {
    let reg = /{(\d+)}/gm
    return fmt.replace(reg, function(match, name) {
      return args[~~name]
    })
  } else if (typeof args == 'object') {
    let reg = /{([^{}]+)}/gm
    return fmt.replace(reg, function(match, name) {
      return args[name]
    })
  }
}

// 金额格式化
const formatMoney = function(number) {
  if (isNaN(number) || number === '') return ''

  number = Math.round(number * 100) / 100
  let output = outputdollars(Math.floor(Math.abs(number) - 0) + '') + outputcents(Math.abs(number) - 0)
  if (number < 0) {
    return '-' + output
  } else {
    return output
  }
}

function outputdollars(number) {
  if (number.length <= 3) {
    return (number == '' ? '0' : number)
  } else {
    var mod = number.length % 3
    var output = (mod == 0 ? '' : (number.substring(0, mod)))
    for (let i = 0; i < Math.floor(number.length / 3); i++) {
      if ((mod == 0) && (i == 0)) {
        output += number.substring(mod + 3 * i, mod + 3 * i + 3)
      } else {
        output += ',' + number.substring(mod + 3 * i, mod + 3 * i + 3)
      }
    }
    return (output)
  }
}

function outputcents(amount) {
  amount = Math.round(((amount) - Math.floor(amount)) * 100)
  return (amount < 10 ? '.0' + amount : '.' + amount)
}

export {
  LLDate,
  formatDateToString,
  formatLeavesDate,
  getQueryString,
  formatFileSize,
  formatString,
  formatMoney
}



// WEBPACK FOOTER //
// ./src/commons/utils/Filters.js